
angular.module('tf.directives')

    .directive('chartTypePicker', function() {
    return {
        restrict: 'E',
        templateUrl: "js/components/charts/chartTypePicker/chartTypePicker.html",
        replace: true,
        scope : {
            type : '='
        },
        link : function(scope, element){


        }

    };
});